import React from 'react';
import { Button } from '@/components/ui/button';

import type { ProgramControlCommonProps, SubmitReportFn } from '../controlTypes';

type InfluenzaProgramControlsProps = ProgramControlCommonProps & {
  influenzaProgramOptions: string[];
  influenzaNotReceivedOptions: string[];
  onSubmitReport: SubmitReportFn;
};

export const InfluenzaProgramControls = ({
  values,
  onFilterChange,
  actionRowClass,
  renderStandardActionButtons,
  renderReportActionLabel,
  influenzaProgramOptions,
  influenzaNotReceivedOptions,
  onSubmitReport,
}: InfluenzaProgramControlsProps) => (
  <div className="mb-3 flex flex-wrap items-end justify-between gap-4 rounded-[var(--border-radius-medium)] border border-[var(--neutral-gray-40)] bg-white px-4 py-3">
    <div className="flex flex-wrap items-center gap-6">
      <div className="flex items-center gap-3">
        <div className="text-xs font-semibold uppercase tracking-wide text-[var(--neutral-gray-100)]">Program</div>
        <select
          value={values.influenzaProgramFilter}
          onChange={(event) => onFilterChange('influenzaProgramFilter', String(event.target.value || 'all'))}
          className="h-8 min-w-[170px] rounded-[var(--border-radius-medium)] border border-[var(--neutral-gray-60)] bg-white px-2 text-xs text-[var(--neutral-gray-120)]"
        >
          <option value="all">All</option>
          {influenzaProgramOptions.map((program) => (
            <option key={program} value={program}>{program}</option>
          ))}
        </select>
      </div>

      <div className="flex items-center gap-3">
        <div className="text-xs font-semibold uppercase tracking-wide text-[var(--neutral-gray-100)]">Not Received</div>
        <select
          value={values.influenzaNotReceivedFilter}
          onChange={(event) => onFilterChange('influenzaNotReceivedFilter', String(event.target.value || 'all'))}
          className="h-8 min-w-[170px] rounded-[var(--border-radius-medium)] border border-[var(--neutral-gray-60)] bg-white px-2 text-xs text-[var(--neutral-gray-120)]"
        >
          <option value="all">All</option>
          {influenzaNotReceivedOptions.map((option) => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
    </div>

    <div className={actionRowClass}>
      {renderStandardActionButtons()}
      <Button type="button" variant="outline" size="sm" className="h-8" onClick={() => onSubmitReport({ action: 'all-fields-report', download: '1' })}>
        {renderReportActionLabel('+ All Fields Report')}
      </Button>
    </div>
  </div>
);
